export class PackageGroupRequest {
  /**
   * @param {String[]} packageIds
   */
  constructor(packageIds) {
    this.packageIds = packageIds;
  }
}
